import * as actionType from "../constants";
import * as commonData from "../Common";

export const showattribute = (inputs) => async (dispatch) => {
  const api = commonData.commonData().apiUrl;
  try {
  } catch (error) {
    console.log(error);
  }
};
